import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../_service/auth.service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PasswordstatusGuard implements CanActivate {
  constructor(private authapi: AuthService,private myRoute: Router){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if(this.authapi.checkpasswordstatus())
    {   
        return true;     
    }
    else
    {   
        localStorage.clear();     
        this.myRoute.navigate(["/login"]);
        return false;
    }
  }
  
}
